import React from "react";
import { Button } from "../Button";
import { connect } from "react-redux";
import language from "../../language";
import { getStorage, setStorage } from "../../utils/storage";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { ListItem } from "../List";
import FilePreviewName from "./FilePreviewName";
import { Loading } from "../Loader";
import {
  fetchBusinessRequiredFiles,
  fetchUserFiles,
  viewUploadedFile,
} from "../../queries/files/fileQuery";
import icons from "../../constants/icons";
import Empty from "../Empty/Empty";
import { saveProfileUnits } from "../../actions/ProfileUnits";
import generateFilename from "../../utils/generateFilename";
import api from "../../utils/api";

class BusinessUploadFiles extends React.Component {
  state = {
    error: {},
    types: [],
    listOfFilesToUpload: [],
    isLoading: false,
    filesUploaded: [],
    countryId: "",
    accountCategoryId: "",
    userFiles: [],
  };

  componentDidMount = async () => {
    let user = await getStorage();
    this.setState({ user });

    this.initialDataFetch(true);
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.businessProfileSavedSuccess !==
      this.props.businessProfileSavedSuccess
    ) {
      this.initialDataFetch(true);
    }
  }

  initialDataFetch = async (isLoading) => {
    await this.getFileTypes(isLoading);
    await this.getAuthenticatedUserFiles(isLoading);
    await this.handleUpdateProfileUnitsStorage("DOCUMENTS");
  };

  handleUpdateProfileUnitsStorage = async (unit) => {
    const { profileUnits } = this.props;

    const modifiedUnits = profileUnits?.map((el) => {
      if (el.unit === unit && !el.provided) {
        el.provided = true;
      }

      return el;
    });

    await this.props.dispatch(saveProfileUnits(modifiedUnits));
  };

  getFileTypes = async (isLoading) => {
    const { defaultLanguage, profileUnitsId } = this.props;
    const user = await getStorage();
    try {
      this.setState({ isLoading });

      let requiredDocument = (requiredDocument =
        await fetchBusinessRequiredFiles(defaultLanguage, {
          profileUnitsId,
        }));

      this.setState({
        isLoading: false,
        listOfFilesToUpload: requiredDocument,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  getAuthenticatedUserFiles = async (isLoading) => {
    const { defaultLanguage } = this.props;

    try {
      this.setState({ isLoading });

      const files = await fetchUserFiles(defaultLanguage);

      const userFiles = await Promise.all(
        files.map(async (file) => {
          const url = await viewUploadedFile(defaultLanguage, {
            fileId: file.id,
          });
          return {
            ...file,
            tmpURL: url,
          };
        })
      );

      this.setState({
        isLoading: false,
        userFiles: userFiles || [],
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handleViewFile = async (fileId) => {
    const { defaultLanguage } = this.props;

    try {
      return await viewUploadedFile(defaultLanguage, { fileId });
    } catch (error) {
      console.log(error);
    }
  };

  onChangeInput(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      error,
      [field]: e.target ? e.target.value : e,
    });

    let listOfFilesToUpload = [];
    this.setState({ listOfFilesToUpload });
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      ...selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  handleBeforeUpload = (file) => {
    const newName = generateFilename(file.name);
    const newFile = new File([file], newName, { type: file.type });
    return newFile;
  };

  handleFiles(file, index) {
    let modifiedFile = this.handleBeforeUpload(file);

    let { listOfFilesToUpload, error } = this.state;

    delete error[listOfFilesToUpload[index].type];

    listOfFilesToUpload[index]["uploadedFile"] = modifiedFile;

    this.setState({ listOfFilesToUpload, error });
  }

  handleRemoveFile(i) {
    let { listOfFilesToUpload } = this.state;

    delete listOfFilesToUpload[i].uploadedFile;

    this.setState({ listOfFilesToUpload });
  }

  validateForm() {
    let { error, listOfFilesToUpload, userFiles } = this.state;

    listOfFilesToUpload?.forEach((el) => {
      if (
        !el.uploadedFile &&
        !userFiles.find((userFile) => userFile.fileTypeId === el.id)
      ) {
        error[el.type] =
          el.type + " " + language[this.props.defaultLanguage].is_mandatory;
      }
    });

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    let { error, listOfFilesToUpload, user, userFiles } = this.state;

    if (Object.keys(error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      const upload = new Promise((resolve, reject) => {
        listOfFilesToUpload?.forEach((el) => {
          if (userFiles.find((userFile) => userFile.fileTypeId === el.id))
            return;

          let formData = new FormData();

          formData.append("fileTypeId", el.id);

          formData.append("fileToUpload", el.uploadedFile);

          const options = {
            method: "POST",
            url: `${api("file")}/upload`,
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + user.accessToken,
            },
          };

          axios(options)
            .then((data) => {
              toastMessage(
                "success",
                language[this.props.defaultLanguage].upload_file_success
              );

              resolve(data);
            })
            .catch((error) => {
              this.setState({
                isSubmitting: false,
              });

              toastMessage(
                "error",
                language[this.props.defaultLanguage].upload_file_error +
                  " " +
                  el.type
              );

              reject(error);
            });
        });
      });

      upload
        .then(() => {
          this.setState({
            isSubmitting: false,
          });

          if (this.props.handleCollapsePreviousAndShowNext) {
            this.props.handleCollapsePreviousAndShowNext();
          }

          this.initialDataFetch(true);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  handleShowModal(modal) {
    this.setState({
      [modal]: true,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  handleApprovedAccount = async () => {
    let { user, verified } = this.state;

    this.setState({ isNavigating: true });

    if (verified) {
      await setStorage(user);
      window.location.href = "/merchant/analytics";
    }

    this.setState({ isNavigating: false });
  };

  render() {
    return (
      <>
        {this.state.isLoading ? (
          <Loading fullScreen />
        ) : this.state?.listOfFilesToUpload?.length > 0 ? (
          <>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  {this.state.listOfFilesToUpload?.map((el, i) => {
                    const uploadedFile = this.state?.userFiles?.find(
                      (flEl) => flEl.fileTypeId === el.id
                    );

                    return (
                      <>
                        <ListItem
                          name={el.type}
                          status={el.uploaded}
                          key={i}
                          required
                          rightIcon={el.uploaded && icons.success}
                          rightButtons={
                            uploadedFile?.tmpURL
                              ? [
                                  {
                                    icon: icons.download,
                                    type: "button",
                                    onPress: () =>
                                      window.open(
                                        uploadedFile.tmpURL,
                                        "_blank"
                                      ),
                                  },
                                ]
                              : !el.uploadedFile && [
                                  {
                                    name: "Upload",
                                    type: "upload",
                                    onPress: (file) =>
                                      this.handleFiles(file, i),
                                  },
                                ]
                          }
                          error
                        />
                        {el.uploadedFile && (
                          <>
                            <FilePreviewName
                              name={el?.uploadedFile?.name}
                              type={el?.uploadedFile?.type}
                              handleRemoveFile={() => this.handleRemoveFile(i)}
                            />
                            <hr />
                          </>
                        )}
                        {this.state.error[el.type] && (
                          <div style={{ minHeight: 40, marginLeft: "1rem" }}>
                            <span className="text-error">
                              {this.state.error[el.type]}
                            </span>
                          </div>
                        )}
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className={`modal-footer ${this.props.footerClassName}`}>
              {this.state?.userFiles?.length > 0 &&
              this.state?.listOfFilesToUpload?.length <=
                this.state?.userFiles?.length ? (
                <>
                  <Button
                    text={`${this.state?.userFiles?.length} ${
                      language[this.props.defaultLanguage].files_attached
                    }`}
                    onPress={() => this.handleShowModal("showFileManagerModal")}
                    className="btn-transparent primary"
                  />
                  {this.state.user.verified && (
                    <Button
                      text={language[this.props.defaultLanguage].goto_dashboard}
                      onPress={() => this.handleApprovedAccount()}
                      isSubmitting={this.state.isNavigating}
                    />
                  )}
                </>
              ) : (
                <Button
                  text={language[this.props.defaultLanguage].submit}
                  onPress={this.onSubmit.bind(this)}
                  isSubmitting={this.state.isSubmitting}
                />
              )}
            </div>
          </>
        ) : (
          this.state?.userFiles?.length === 0 && (
            <Empty
              title={
                language[this.props.defaultLanguage].business_category_id_first
              }
              showButton
              buttonText={
                language[this.props.defaultLanguage].add_business_profile
              }
              buttonPressed={() =>
                (window.location.href =
                  "/merchant/kyc/onboarding#businessProfile")
              }
            />
          )
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { businessProfileSavedSuccess } = state.BusinessProfile;
  const { profileUnits } = state.ProfileUnits;
  return {
    defaultLanguage,
    businessProfileSavedSuccess,
    profileUnits,
  };
};

export default connect(mapStateToProps)(BusinessUploadFiles);
